import { formatPrice } from './numberFormat';

export default function formatePriceByCost(
  price?: number,
  unit?: string,
  weight?: number,
): string {
  if (!price) return '-';
  if (price < 1) return `$ ${price} ${unit || ''}`;
  if (!weight) return `$ ${price} ${unit || ''}`;

  return `$${formatPrice(String(price / weight))} ${unit || ''}`;
}
